// main-product
class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(
      `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
    ).forEach((element) => {
      element.classList.remove('active');
    });
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    if (
      activeMedia.nodeName == 'DEFERRED-MEDIA' &&
      activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
    ) {
      activeMedia.loadContent();
    }
  }
}

const mainProduct = () => {
  customElements.define('product-modal', ProductModal as any);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    product_id: Shopify.product.id,
    variant_price: Math.floor(Shopify.product.price / 100),
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof productBrandList !== 'undefined' && Shopify.product.vendor) {
      const elementList = document.querySelectorAll('.link_brand_page');
      const vendor = Shopify.product.vendor;
      if (vendor in productBrandList) {
        const productBrand = productBrandList[vendor];
        const displayName = productBrand.display_name;
        const pageId = productBrand.page;
        const displayText = displayName + 'のページを表示';
        elementList.forEach(function (element) {
          const linkText = document.createTextNode(displayText);
          const anchor = document.createElement('a');
          anchor.appendChild(linkText);
          anchor.title = displayName;
          anchor.href = '/pages/' + pageId;
          element.appendChild(anchor);
        });
      }
    }
  });
};

export default mainProduct;
